import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParamsOfBooking } from "../../hooks/searchParams/useSearchParamsOfBooking";
import VoucherService from "../../services/voucherService";

const useVoucherBox = (props: VoucherBoxProps) => {
  const { productIds } = props;
  const [voucher, setVoucher] = useState("");
  const [error, setError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setVoucher(e.target.value);
    setError("");

    props.onApply(undefined);
    setError("");
    setIsSuccess(false);
    setSelectVoucher(undefined);
  };

  const [selectedVoucher, setSelectVoucher] = useState<VoucherResponse>();

  const handleApply = async () => {
    // // // Check if the voucher contains only uppercase letters and numbers
    // // const isValid = /^[A-Z0-9]+$/.test(voucher);
    // if (!voucher.trim()) {
    //   setError(t("The promo code you entered is invalid."));
    //   setIsSuccess(false);
    //   return;
    // }
    // if (props?.voucherId) {
    //   setVoucher("");
    //   props.onApply(undefined);
    //   setError("");
    //   setIsSuccess(false);
    //   setSelectVoucher(undefined);
    //   return;
    // }
    // if (!selectedVoucher?.id) return;
    // props.onApply(selectedVoucher?.id);
    // setError("");
    // setIsSuccess(true);
    // Fetch vouchers based on the keyword and productIds
    if (!voucher.trim()) {
      setError("The promo code you entered is invalid.");
      setIsSuccess(false);

      return;
    }
    const v = (
      await VoucherService.find({
        keyword: voucher,
        productIds,
      })
    ).data?.[0];
    if (!v?.id) {
      setError("The promo code you entered is invalid.");
      setIsSuccess(false);
      return;
    }

    props.onApply(v.id);
    setError("");
    setIsSuccess(true);
    setSelectVoucher(v);
  };

  const handleFocus = () => {
    if (isSuccess) return;
    console.log("==== handleFocus");
    setIsFocused(true);
  };
  const handleBlur = () => {
    console.log("==== handleBlur");
    setTimeout(() => {
      setIsFocused(false);
    }, 200);
  };

  return {
    voucher,
    error,
    isSuccess,
    handleInputChange,
    handleApply,
    selectedVoucher,
    setSelectVoucher,
    handleFocus,
    handleBlur,
    isFocused,
    setVoucher,
    ...props,
  };
};

type VoucherBoxProps = {
  productIds: number[];
  voucherId?: number;
  onApply: (voucherId?: number) => void;
};
export const VoucherBox = (props: VoucherBoxProps) => {
  const jj = useVoucherBox(props);
  const { isEdit, isUpgrade } = useSearchParamsOfBooking();
  const disabled = isEdit || isUpgrade;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-start gap-[1.50rem]">
      <h6 className="text-[1.13rem] font-semibold text-gray-900">
        {t("Promotion")}
      </h6>
      <div
        className={clsx(
          "flex flex-col items-center justify-between self-stretch",
          disabled && "pointer-events-none opacity-50",
        )}
      >
        <div className="flex flex-row items-center justify-between gap-8 self-stretch">
          <p className="text-sm text-gray-600 sm:text-base">
            {t("Promote code")}
          </p>
          <div className="relative flex w-full items-center gap-[0.75rem] rounded-[1.5rem] border border-solid border-gray-300 p-[0.50rem] sm:w-[16.25rem]">
            <input
              className="w-full text-[0.88rem] focus:border-[#DCDCDC] focus:outline-none"
              placeholder={t("Enter or select voucher")}
              type="text"
              value={jj.voucher}
              onChange={jj.handleInputChange}
              onFocusCapture={() => jj.handleFocus()}
            />
            <button
              onClick={jj.handleApply}
              className={`flex h-[2.13rem] min-w-[4.38rem] cursor-pointer flex-row items-center justify-center whitespace-nowrap rounded-[1rem] px-[1.00rem] text-center text-[0.88rem] font-semibold ${
                jj.isSuccess
                  ? "bg-[#007aff] text-white"
                  : "bg-[#dbe7ff] text-[#007aff]"
              }`}
            >
              {jj.isSuccess ? t("Applied") : t("Apply")}
            </button>
            {/* {
              // Show the dropdown only when the input is focused
              jj.isFocused && <VoucherDropDown {...jj} />
            } */}
          </div>
        </div>
        {!!jj.error && (
          <div className="w-full">
            <p className="ml-auto w-[18rem] text-end text-[0.875rem] text-[#DA3838]">
              {t(jj.error)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

// const VoucherDropDown = ({
//   selectedVoucher,
//   setSelectVoucher,
//   setVoucher,
//   voucher: keyword,
//   productIds,
//   handleBlur,
// }: TUseVoucherBox) => {
//   const ref = useRef<HTMLDivElement>(null);
//   useClickOutside({
//     ref,
//     onOutsideClick: () => handleBlur(),
//   });

//   const query = useQuery<PageResult<VoucherResponse>>({
//     queryKey: ["voucher", keyword, productIds.toString()],
//     queryFn: async () => {
//       // Fetch vouchers based on the keyword and productIds
//       const res = await axiosInstance.get("/vouchers/active", {
//         params: {
//           keyword,
//           productIds: productIds.toString(),
//           pageSize: 5,
//           pageIndex: 0,
//         },
//       });
//       return res.data.result;
//     },
//     keepPreviousData: true,
//   });
//   return (
//     <div
//       ref={ref}
//       className="absolute right-0 top-14 w-full rounded-3xl bg-white shadow"
//     >
//       <div className="flex w-full flex-col">
//         {query.data?.data?.map?.((voucher) => {
//           return (
//             <div
//               key={voucher.id}
//               className="flex w-full flex-row items-center justify-between border-b border-[#EAEEF3] p-4"
//             >
//               <label
//                 className={clsx(
//                   "flex w-full justify-between text-sm font-normal leading-[1.1875rem]",
//                   {
//                     "text-[#232323]":
//                       !selectedVoucher || selectedVoucher?.id === voucher.id,
//                     "text-[#BFC5C9]":
//                       selectedVoucher && selectedVoucher?.id !== voucher.id,
//                   },
//                 )}
//               >
//                 {voucher.name}
//                 <CustomRadio
//                   selected={selectedVoucher?.id === voucher.id}
//                   onClick={() => {
//                     setSelectVoucher(voucher);
//                     setVoucher(voucher.name);
//                   }}
//                 />
//               </label>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };
